exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-inner[data-v-05f6edd0]{border:2px solid #e8eaf6;border-radius:4px}.border-radius-bottom-0[data-v-05f6edd0]{border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-right-radius:0;border-top-left-radius:0}", ""]);

// exports
